var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2705-Feather-(Neutral)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Versicherte---Ge\\xE4nderter-Zustand",
    transform: "translate(-967.000000, -274.000000)",
    className: "toggle",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Person",
    transform: "translate(112.000000, 249.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(856.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,2 L1.66666667,2 C0.746192084,2 0,2.74619208 0,3.66666667 L0,15.3333333 C0,16.2538079 0.746192084,17 1.66666667,17 L13.3333333,17 C14.2538079,17 15,16.2538079 15,15.3333333 L15,9.5",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9226784,0.527984889 C14.6266583,-0.175994974 15.7680352,-0.175994962 16.4720151,0.527984916 C17.175995,1.23196479 17.175995,2.37334169 16.4720151,3.07732158 L8.39911559,11.1502211 L5,12 L5.8497789,8.60088441 L13.9226784,0.527984889 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.17cd08b7faabf9c0ca52fcc24d64bbdd.svg";
export { ForwardRef as ReactComponent };